export default function FunnelLogo() {
  return (
    <div className="flex items-center gap-2">
      <img
        alt=""
        className="h-8 w-8 rounded-lg"
        src="/android-chrome-192x192.png"
      />

      <span
        className="text-lg font-bold tracking-tight text-vm-ink"
        translate="no"
      >
        VisualMind
      </span>
    </div>
  )
}
